<template>
  <td>{{ $e("Hauteur max")}} :</td>
  <td>
    {{ HeightMax }} m
  </td>
  <td></td>
</template>
<script>
export default {
  props: {
    config: Object,
    cheack: Object
  },
  computed: {
    HeightMax() {
      let height_limit = this.config?.drone?.status?.height_limit != null
        ? parseInt(this.config.drone?.status.height_limit)
        : ENV.NO_DATA;

      return height_limit
    },
  },
};
</script>
